export default {
    NONE: 'none',
    ABOVE_GROUND_FENCE: 'above-ground-fence',
    ABOVE_GROUND_NO_FENCE: 'above-ground-no-fence',
    INDOOR: 'indoor',
    IN_GROUND_FENCE: 'in-ground-fence',
    IN_GROUND_NO_FENCE: 'in-ground-no-fence',
};
